import ReactMarkdown from 'react-markdown';
import RemarkGfm from 'remark-gfm';

import { Container } from '../components/container/container';
import { Heading } from '../components/heading/heading';
import { Content, Copy } from '../components/register-screens/shared';
import { COOKIE_POLICY_MD } from '../data/markdown/cookie-policy';

export function CookiePolicy() {
  return (
    <Container>
      <Content>
        <Heading center>Cookie Policy</Heading>
        <Copy>
          <ReactMarkdown remarkPlugins={[RemarkGfm]}>
            {COOKIE_POLICY_MD}
          </ReactMarkdown>
        </Copy>
      </Content>
    </Container>
  );
}
